"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _generateRandomId = require("../../utils/generateRandomId");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _checkLarge = _interopRequireDefault(require("../../svg/check-large.svg"));

var _checkSmall = _interopRequireDefault(require("../../svg/check-small.svg"));

var _variables = require("../../styles/variables");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var sizes = {
  sm: (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 20px;\n    height: 20px;\n    margin-left: 14px;\n\n    &:after {\n      width: 20px;\n      height: 20px;\n    }\n\n    &:checked:after {\n      background: url(", ");\n      background-repeat: no-repeat;\n      background-position: center;\n      background-color: ", ";\n    }\n  "])), _checkSmall["default"], _variables.colors.father),
  lg: (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 24px;\n    height: 24px;\n    margin-left: 20px;\n\n    &:after {\n      width: 24px;\n      height: 24px;\n    }\n\n    &:checked:after {\n      background: url(", ");\n      background-repeat: no-repeat;\n      background-position: center;\n      background-color: ", ";\n    }\n  "])), _checkLarge["default"], _variables.colors.father)
};

var StyledCheckWrapper = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  direction: rtl;\n  display: flex;\n  align-items: center;\n  font-family: IranSansX, sans-serif;\n"])));

var disabled = (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  &:after {\n    border-color: ", ";\n  }\n\n  color: ", ";\n"])), _variables.colors.whale, _variables.colors.whale);

var StyledCheckboxLabel = _styledComponents["default"].label(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin: 0;\n  padding-top: 3px;\n  font-size: ", ";\n  font-weight: ", ";\n  user-select: none;\n  ", "\n"])), function (_ref) {
  var size = _ref.size;
  return size === "sm" ? "10px" : "";
}, function (_ref2) {
  var size = _ref2.size;
  return size === "sm" ? "100" : "";
}, function (props) {
  return props.disabled && disabled;
});

var StyledCheckbox = _styledComponents["default"].input(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  appearance: none;\n  position: relative;\n\n  &:after {\n    content: \"\";\n    border: 1px solid ", ";\n    border-radius: 6px;\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n\n  ", "\n  ", "\n"])), _variables.colors.father, function (props) {
  return props.size && sizes[props.size];
}, function (props) {
  return props.disabled && disabled;
});

var Checkbox = function Checkbox(props) {
  var label = props.label;
  var checkboxId = (0, _generateRandomId.generateRandomId)(20);
  return /*#__PURE__*/_react["default"].createElement(StyledCheckWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledCheckbox, _extends({
    type: "checkbox",
    id: checkboxId
  }, props)), /*#__PURE__*/_react["default"].createElement(StyledCheckboxLabel, {
    htmlFor: checkboxId
  }, label));
};

exports.Checkbox = Checkbox;
Checkbox.propTypes = {
  /** label of checkbox */
  label: _propTypes["default"].string,

  /** size of checkbox */
  size: _propTypes["default"].oneOf(["lg", "sm"]),
  checked: _propTypes["default"].bool,
  onChange: _propTypes["default"].func
};
Checkbox.defaultProps = {
  label: null,
  size: "lg"
};